"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { useLocale } from "@/context/LocaleContext"

export function NavbarCTAButton({ className = "" }: { className?: string }) {
  const { t } = useLocale();
  const pathname = usePathname() || "";
  const isEnglish = pathname.startsWith("/en");

  const handleClick = () => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("preSelectedPackage");
    }
  };

  const localizedHref = isEnglish ? "/en/add-event" : "/add-event";

  return (
    <Link
      href={localizedHref}
      onClick={handleClick}
      style={{ backgroundColor: "#E85C57" }}
      className={`
        relative z-[1] cursor-pointer select-none
        inline-flex items-center justify-center gap-2
        rounded-full font-semibold text-white
        transition-all duration-300 hover:shadow-lg hover:brightness-90
        h-[45px] px-6 text-[14px]
        md:h-[50px] md:px-8 md:text-[15px]
        ${className}
      `}
    >
      {t("AllInOne.btn_create") || "Buat Gratis Sekarang"}
    </Link>
  )
}

export function HomeCTAButton({ className = "" }: { className?: string }) {
  const { t } = useLocale();
  const pathname = usePathname() || "";
  const isEnglish = pathname.startsWith("/en");

  const handleClick = () => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("preSelectedPackage");
    }
  };

  const localizedHref = isEnglish ? "/en/add-event" : "/add-event";

  return (
    <Link
      href={localizedHref}
      onClick={handleClick}
      style={{ backgroundColor: "#E85C57" }}
      className={`
        relative z-[1] cursor-pointer select-none
        inline-flex items-center justify-center gap-2
        rounded-full font-semibold text-white
        transition-all duration-300 hover:shadow-lg hover:brightness-90
        h-[55px] px-8 text-[1.1rem]
        md:h-[60px] md:px-10 md:text-[1.15rem]
        ${className}
      `}
    >
        {t("AllInOne.btn_create")}
    </Link>
  )
}